import { render, staticRenderFns } from "./treeMenu.vue?vue&type=template&id=41131726&scoped=true&"
import script from "./treeMenu.vue?vue&type=script&lang=js&"
export * from "./treeMenu.vue?vue&type=script&lang=js&"
import style0 from "./treeMenu.vue?vue&type=style&index=0&id=41131726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41131726",
  null
  
)

export default component.exports